export const alloggiati = {
  title: "Alloggiati Web",
  subtitle: "Notifica elettronica degli alloggiati — Polizia di Stato",

  fields: {
    utente: "Utente",
    password: "Password",
    wskey: "WsKey",
    wskeyHint: "La WsKey viene generata nel portale alloggiatiweb.poliziadistato.it → Gestione dispositivi.",
    tipoStruttura: "Tipo di struttura",
    idAppartamento: "ID Appartamento",
    idAppartamentoHint: "ID dell'appartamento registrato in Alloggiati Web.",
    keepBlank: "(lasciare vuoto per mantenere il valore attuale)",
  },

  tipoOptions: {
    hotel: "Hotel / B&B / Casa vacanze",
    appartamento: "Appartamento gestito",
  },

  actions: {
    saveAndVerify: "Salva e verifica",
    updateCredentials: "Aggiorna credenziali",
    verifyConnection: "Verifica connessione",
    saving: "Salvataggio in corso...",
    verifying: "Verifica in corso...",
  },

  status: {
    connectionOk: "Credenziali salvate e connessione verificata correttamente.",
    connectionError: "Errore di connessione. Verifica le credenziali inserite.",
    connectionPending: "Connessione non ancora verificata. Clicca su «Verifica connessione» per confermare.",
  },

  validation: {
    utenteRequired: "Il campo Utente è obbligatorio.",
    passwordRequired: "La password è obbligatoria.",
    wskeyRequired: "La WsKey è obbligatoria.",
    idAppartamentoRequired: "L'ID appartamento è obbligatorio.",
  },

  toasts: {
    saveSuccess: "Credenziali salvate e connessione verificata correttamente.",
    saveWarning: "Credenziali salvate, ma la connessione non è stata verificata.",
    saveError: "Impossibile salvare le credenziali.",
    testSuccess: "Connessione con Alloggiati Web verificata correttamente.",
    testError: "Impossibile verificare la connessione.",
    statusActive: "Alloggiati Web attivato.",
    statusInactive: "Alloggiati Web disattivato.",
  },
};
